"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function (o, m, k, k2) {
    if (k2 === undefined)
        k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
        desc = { enumerable: true, get: function () { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function (o, m, k, k2) {
    if (k2 === undefined)
        k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function (o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function (o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function (o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o)
                if (Object.prototype.hasOwnProperty.call(o, k))
                    ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule)
            return mod;
        var result = {};
        if (mod != null)
            for (var k = ownKeys(mod), i = 0; i < k.length; i++)
                if (k[i] !== "default")
                    __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.useTableColumns = void 0;
const react_1 = require("react");
const constants_1 = require("../../constants");
const localization_1 = require("../../localization");
const consolidated_list_1 = require("../components/consolidated-list");
const State = __importStar(require("../../store/state"));
const useTableColumns = ({ activeColumns, additionalTemplate = {} }) => {
    const { formatMessage: t } = (0, localization_1.useLocalization)();
    const baseTemplate = (0, react_1.useMemo)(() => ({
        [State.PRODUCT_EDITOR_TABLE_COLUMNS.PRODUCT_ID]: { align: 'left', label: t({ key: State.PRODUCT_EDITOR_TABLE_COLUMNS.PRODUCT_ID }), value: 'id' },
        [State.PRODUCT_EDITOR_TABLE_COLUMNS.SKU_ID]: { align: 'left', label: t({ key: State.PRODUCT_EDITOR_TABLE_COLUMNS.SKU_ID }), value: 'proprietaryId' },
        [State.PRODUCT_EDITOR_TABLE_COLUMNS.IMAGE]: { align: 'left', label: t({ key: State.PRODUCT_EDITOR_TABLE_COLUMNS.IMAGE }) },
        [State.PRODUCT_EDITOR_TABLE_COLUMNS.NAME]: { align: 'left', label: t({ key: State.PRODUCT_EDITOR_TABLE_COLUMNS.NAME }), value: 'title' },
        [State.PRODUCT_EDITOR_TABLE_COLUMNS.DESCRIPTION]: { align: 'left', label: t({ key: State.PRODUCT_EDITOR_TABLE_COLUMNS.DESCRIPTION }), value: 'description' },
        [State.PRODUCT_EDITOR_TABLE_COLUMNS.PRODUCT_GROUP]: { align: 'left', label: t({ key: State.PRODUCT_EDITOR_TABLE_COLUMNS.PRODUCT_GROUP }), value: 'variantGroupId' },
        [State.PRODUCT_EDITOR_TABLE_COLUMNS.CREATED_DATE]: { align: 'left', label: t({ key: State.PRODUCT_EDITOR_TABLE_COLUMNS.CREATED_DATE }), value: 'createdAt' },
        [State.PRODUCT_EDITOR_TABLE_COLUMNS.LAST_MODIFIED]: { align: 'left', label: t({ key: State.PRODUCT_EDITOR_TABLE_COLUMNS.LAST_MODIFIED }), value: 'updatedAt' },
        [State.PRODUCT_EDITOR_TABLE_COLUMNS.CLASS]: { align: 'left', label: t({ key: State.PRODUCT_EDITOR_TABLE_COLUMNS.CLASS }), value: 'classId' },
        [State.PRODUCT_EDITOR_TABLE_COLUMNS.URL]: { align: 'left', label: t({ key: State.PRODUCT_EDITOR_TABLE_COLUMNS.URL }), value: 'url' },
        [State.PRODUCT_EDITOR_TABLE_COLUMNS.ACTIVE_STATUS]: { align: 'left', label: t({ key: State.PRODUCT_EDITOR_TABLE_COLUMNS.ACTIVE_STATUS }), value: 'active' },
        // descoped for MVP
        // [State.PRODUCT_EDITOR_TABLE_COLUMNS.PRICE]: { align: 'left', label: t({ key: State.PRODUCT_EDITOR_TABLE_COLUMNS.PRICE }) },
        [State.PRODUCT_EDITOR_TABLE_COLUMNS.COMMENTS]: { align: 'left', label: t({ key: State.PRODUCT_EDITOR_TABLE_COLUMNS.COMMENTS }), value: 'totalComments' },
        [State.PRODUCT_EDITOR_TABLE_COLUMNS.CURATED_ATTRIBUTES]: {
            id: constants_1.ColumnId.CuratedAttributes,
            align: 'left',
            label: t({ key: State.PRODUCT_EDITOR_TABLE_COLUMNS.CURATED_ATTRIBUTES }),
            filterable: true,
            CustomIcon: consolidated_list_1.AttributeLegendTooltip,
        },
        [State.PRODUCT_EDITOR_TABLE_COLUMNS.STANDARD_FIELDS]: { align: 'left', label: t({ key: State.PRODUCT_EDITOR_TABLE_COLUMNS.STANDARD_FIELDS }) },
    }), [t]);
    const template = (0, react_1.useMemo)(() => (Object.assign(Object.assign({}, baseTemplate), additionalTemplate)), [additionalTemplate, baseTemplate]);
    return (0, react_1.useMemo)(() => (activeColumns.map((item) => template[item])), [activeColumns, template]);
};
exports.useTableColumns = useTableColumns;
